import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/constructionAsset/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/cityDigital/img/1.avif';
import image2 from '@src/assets/images/solution/cityDigital/img/2.avif';
import image3 from '@src/assets/images/solution/cityDigital/img/3.avif';
import image4 from '@src/assets/images/solution/cityDigital/img/4.avif';
import image5 from '@src/assets/images/solution/cityDigital/img/5.avif';
import image6 from '@src/assets/images/solution/cityDigital/img/6.avif';
import image7 from '@src/assets/images/solution/cityDigital/img/7.avif';
import image8 from '@src/assets/images/solution/cityDigital/img/8.avif';

export default {
  type: '도시 솔루션',

  banner: {
    title: '도시 전체를 실시간으로 모니터링, 디지털 재난 대응 체계',
    desc: '도시의 공간 데이터를 3D 디지털 트윈으로 구현하여 재난 발생 전후 상황을 예측·대응·복구까지 통합 관리할 수 있는 플랫폼을 제공합니다.',
  },

  video: {
    title: '디지털 트윈으로 재난 관리의 모든 과정을 실시간으로 연결하세요',
    desc: '실제 도시를 가상 공간에 구현하고 센서·위치 데이터·카메라 영상 등 다양한 정보를 실시간으로 반영하여 재난 전 조기 경보, 발생 중 대응, 사후 복구를 하나의 시스템으로 운영합니다.',
    play: video,
  },

  func: [
    {
      theme: '도시 재난 정보 통합 및 실시간 시각화',
      title: '도시 인프라 기반 통합 모니터링',
      desc: '재난 대응에 필요한 각종 도시 인프라 데이터를 하나의 플랫폼에서 통합 관리합니다. 도로, 하천, 시설물, 센서 데이터를 연계하여 실시간으로 도시 전역의 위험 요소를 확인할 수 있습니다.',
      sub1: '실시간 현황 파악',
      icon1: IconClockGray,
      sub2: '빠른 데이터 연동',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: '기상 정보 실시간 수집 및 분석',
      desc: '위성 영상, 일기도, 레이더 데이터 등 기상 정보를 실시간 수집하고, 악천후 상황에 대비한 예측 및 알림 시스템을 제공합니다. 도시의 기상 환경을 수치화하여 시나리오 대응 기반으로 활용할 수 있습니다.',
      sub1: '위험 자산 지정',
      icon1: IconWarningGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image2,
    },
    {
      title: '지역별 강우현황 실시간 확인',
      desc: '도시 내 설치된 우량계를 통해 지역별 강우 상태를 실시간으로 수집·분석합니다. 집중호우 발생 시 특정 지역에 대한 우선 대응 판단이 가능해집니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image3,
    },
    {
      title: '하천 수위 및 유량 상태 시각화',
      desc: '낙동강·내성천 등 주요 하천의 수위, 유량, 수문 상태를 실시간으로 시각화합니다. 이상 수위 발생 시 자동 감지되어 위험 경보를 발송할 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      theme: '재난 대응 자동화 및 상황실 활용',
      title: '종합상황 기반 알람 연계',
      desc: '다양한 데이터를 종합하여 상황실 화면에서 위험을 한눈에 확인할 수 있습니다. 상황별 판단 기준에 따라 맞춤형 경고 및 대응 트리거를 자동으로 실행합니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: '상황실 화면 구성 및 실시간 표출',
      desc: '재난종합상황실에서는 CCTV, 경보 이력, 주요 하천 수위 등을 대형 스크린에 분할 구성하여 실시간 모니터링합니다. 상황실 전용 구성으로 현장 대응력을 높이고 전체 재난 상황을 빠르게 공유할 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image6,
    },
    {
      title: '재난 시 원격 대응 체계',
      desc: 'TTS 기반 마을방송 송출, 문자 전송, CCTV 영상 모니터링, 원격 차단기 제어 등 재난 시 원격에서 즉각적인 조치를 취할 수 있습니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image7,
    },
    {
      title: '다중 패널 데이터 시각화',
      desc: '기상정보, 수위, 강우량, 경보 지표 등을 통합하여 구성된 데이터 패널을 제공합니다. 각종 환경 정보를 하나의 화면에서 직관적으로 비교·판단할 수 있어 상황 인식과 대응 결정이 빨라집니다.',
      sub1: '통계 데이터 제공',
      icon1: IconChartBarGray,
      sub2: '데이터 클라우드 저장',
      icon2: IconCloudCheckGray,
      image: image8,
    },
  ],

  subfunc: {
    title: '주요기능 요약',
    desc: '의료 폐기물은 끝까지 긴장을 놓쳐서는 안됩니다. 작은 방심과 실수로도 큰 의료 사고로 이어질 수 있습니다. 따라서 매우 정밀한 관리가 필요하며 안전이 보장되어야 합니다.<br/>오브로는 안전하고 효율적인 의료 시설을 구축하기 위해 다양한 기능을 제공합니다.',

    data: [
      {
        icon: IconDashboard,
        title: '도시 전역 통합 모니터링',
        desc: '도로, 하천, 시설물 등 도시 인프라 데이터를 하나의 플랫폼에서 통합 관리합니다.',
      },
      {
        icon: IconClockGray,
        title: '기상 정보 실시간 수집',
        desc: '레이더, 위성 영상, 일기도 등 다양한 기상 정보를 실시간으로 수집하고 시각화합니다.',
      },
      {
        icon: IconChartBarGray,
        title: '지역별 강우량 자동 분석',
        desc: '우량계를 통해 수집된 지역별 강우 데이터를 자동 분석해 침수 우려 지역을 구분합니다.',
      },
      {
        icon: IconChartBarGray,
        title: '하천 수위 및 유량 모니터링',
        desc: '낙동강, 내성천 등 주요 하천의 수위·유량 정보를 실시간 수치화하여 경고 기준을 설정합니다.',
      },
      {
        icon: IconDashboard,
        title: '종합상황 대시보드 구성',
        desc: 'CCTV, 수위센서, 경고 알림 등을 종합하여 재난상황을 한눈에 볼 수 있는 대시보드를 제공합니다.',
      },
      {
        icon: IconZoneGray,
        title: '다중 화면 디스플레이 지원',
        desc: '기상, 수위, 경보 등 목적별로 구성된 화면을 상황실 대형 스크린에 맞게 분할 표시할 수 있습니다.',
      },
      {
        icon: IconBell,
        title: '이상 수치 자동 경고 발송',
        desc: '기상 악화, 수위 상승 등 조건을 만족하면 자동으로 알람·문자·마을 방송을 송출할 수 있습니다.',
      },
      {
        icon: IconSecurity,
        title: 'CCTV 연동 및 원격 제어',
        desc: '상황 발생 시 CCTV를 원격 열람하고, 차단기 등의 장비도 원격에서 제어할 수 있습니다.',
      },
      {
        icon: IconRoute,
        title: '재난 시나리오 대응',
        desc: '수집된 데이터를 활용해 시나리오 기반 대응 플랜을 구성하고 자동 실행할 수 있습니다.',
      },
      {
        icon: IconChartRadius,
        title: '모든 기록 이력 자동 저장',
        desc: '상황 발생부터 조치 완료까지의 모든 이력을 자동 기록하여 보고 및 감사 대응이 가능합니다.',
      },
    ],
  },

  system: {
    title: '시스템 구성',
    img: rtlsSystem,
  },

  productTitle: '제품 구성',
  product: [
    {
      tag: 'assetPackage',
    },
    {
      tag: 'workerPackage',
    },
  ],

  contents: [
    {
      data: 'medicalPatient',
    },
    {
      data: 'officeAsset',
    },
    {
      data: 'blogMedical',
    },
    {
      data: 'blogRTLS',
    },
  ],
};
